import React from "react";
import { Share2, Linkedin, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { track } from "@/lib/analytics";

export default function LinkedInShare({ folio, programTitle, issuedAt, className = "" }) {
  const [copied, setCopied] = React.useState(false);
  const verifyUrl = `${window.location.origin}/verificar/${folio}`;
  const date = issuedAt ? new Date(issuedAt) : new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const params = new URLSearchParams({
    startTask: "CERTIFICATION_NAME",
    name: programTitle || "Certificado DCC",
    organizationName: "Debt Capital College",
    issueYear: String(year),
    issueMonth: String(month),
    certUrl: verifyUrl,
    certId: folio,
  });
  const linkedinUrl = `https://www.linkedin.com/profile/add?${params.toString()}`;

  const openLinkedIn = () => {
    track("certificate_shared", { channel: "linkedin", folio });
    window.open(linkedinUrl, "_blank", "noopener,noreferrer");
  };

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Certificado DCC · ${programTitle}`,
          text: `Verifica mi certificado DCC ${folio}`,
          url: verifyUrl,
        });
        track("certificate_shared", { channel: "native", folio });
        return;
      } catch (_) {
        // user cancelled → fall through to copy
      }
    }
    try {
      await navigator.clipboard.writeText(verifyUrl);
      setCopied(true);
      toast.success("Link copiado");
      track("certificate_shared", { channel: "copy", folio });
      setTimeout(() => setCopied(false), 1400);
    } catch (_) {
      toast.error("No se pudo copiar");
    }
  };

  return (
    <div className={`inline-flex flex-wrap gap-2 ${className}`}>
      <button
        type="button"
        onClick={openLinkedIn}
        data-testid={`share-linkedin-${folio}`}
        aria-label="Compartir en LinkedIn"
        className="inline-flex items-center gap-2 text-xs px-3 py-1.5 rounded-md bg-[#0A66C2] hover:bg-[#0055B0] text-white font-semibold"
      >
        <Linkedin className="w-3 h-3" /> LinkedIn
      </button>
      <button
        type="button"
        onClick={share}
        data-testid={`share-native-${folio}`}
        aria-label="Compartir"
        className="inline-flex items-center gap-2 text-xs px-3 py-1.5 rounded-md border border-gray-700 text-gray-200 hover:bg-white/5"
      >
        {copied ? <Check className="w-3 h-3 text-emerald-400" /> : <Share2 className="w-3 h-3" />}
        {copied ? "Copiado" : "Compartir"}
      </button>
    </div>
  );
}
